// --- Dependencies -------------------------------------------------------------------------------
// --- Our Modules --------------------------------------------------------------------------------
import useTranslation from "@/hooks/useTranslation";
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

export type MenuPreviewPopupDetails = {
    /** Already-rendered markup, handed over by whoever fetched it — this popup never fetches. */
    html: string;
    title: string;
};

type Props = {
    onClose: () => void;
    details?: MenuPreviewPopupDetails;
};

// --- Logic --------------------------------------------------------------------------------------

/**
 * The menu preview at full size, stacked over the popup that built it. Opened from the small frame
 * rather than replacing it, so closing this lands the owner back on the settings they were mid-way
 * through rather than at the gallery.
 *
 * It takes the markup it was handed instead of fetching its own, which is what makes opening it
 * instant and keeps the two frames showing the same thing by construction.
 */
export default function MenuPreviewPopup({ onClose, details }: Props) {
    const t = useTranslation();
    if (!details) return null;

    return (
        <div className="menu-preview-popup">
            <div className="mpp-bar">
                <p className="mpp-title">{details.title}</p>
                <button type="button" className="mpp-close" onClick={onClose} aria-label={t.menuTheme.closePreviewLabel}>
                    <img src="/icons/close-icon.svg" alt="" width={16} height={16} />
                </button>
            </div>
            <iframe className="mpp-frame" title={t.menuTheme.previewTitle} srcDoc={details.html} />
        </div>
    );
}
